<template>
  <section class="homeProduct">
    <div class="productTitleBg">以旧换新 > 产品列表</div>
    <div class="productTabs">
      <div class="cats">
        <div class="item"
             :class="catId==29&&'active'"
             @click="onCatId(0)">手机</div>
        <div class="item"
             :class="catId==30&&'active'"
             @click="onCatId(1)">笔记本</div>
      </div>
      <div class="brands">
        <div class="item"
             v-for="(item,index) in brands"
             :class="brandId==item.id&&'bactive'"
             @click="onBrandId(item.id)"
             :key="index"><span>{{item.name}}</span></div>
      </div>
    </div>
    <div class="productBox">
      <div class="item"
           v-for="item in products"
           :key="item.id">
        <router-link :to="{name: 'Product', params: { id: item.id }}">
          <span class="tip">环保补助奖金{{item.bonus_price}}元</span>
          <div class="image"
               :style="'background:url('+item.img+') no-repeat;background-size:100%; '"></div>
          <div class="title">{{item.title}}</div>
          <div class="price">
            新机价格
            <span>¥{{item.price}}</span>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["products", "brands"],
  data () {
    return {
      active: 0,
      bactive: 1,
    };
  },
  computed: {
    brandId () {
      return this.$store.state.product.brandId;
    },
    catId () {
      return this.$store.state.product.catId;
    }
  },
  mounted () {
    if (this.catId == 30) {
      this.active = 1
    }
  },
  methods: {
    onCatId (id) {
      this.active = id;
      let catId = 29
      if (id == 1) {
        catId = 30
      }
      this.$store.commit('product/setCatId', catId);
      this.$store.commit('product/setBrandId', 0);
      this.$emit("getProductList")
    },
    onBrandId (id) {
      this.bactive = id
      this.$store.commit('product/setBrandId', id);
      this.$emit("getProductList")
    }
  }
};
</script>

<style scoped>
.homeProduct {
  margin: 50px auto 0;
}
.productTitleBg {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 14px;
}
.productTabs {
  margin-top: 30px;
  width: 1200px;
}
.productTabs .cats {
  display: flex;
  height: 78px;
  line-height: 78px;
  background: #fff;
  border-bottom: solid #fad07c 3px;
}
.productTabs .brands {
  display: flex;
  height: 78px;
  line-height: 78px;
  background: #fff;
}
.productTabs .brands .item {
  width: 33.33%;
  text-align: center;
}
.productTabs .brands .item.bactive {
  color: #f4445f;
}
.productTabs .cats .active {
  background: rgba(250, 208, 124, 1);
}
.productTabs .cats .item {
  text-align: center;
  width: 50%;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.limitedTime {
  text-align: center;
  margin: 20px 0;
  color: #666;
}
.limitedTime span {
  font-size: 16px;
}
.limitedTime span:nth-child(2n) {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #333;
  color: #fff;
  border-radius: 2px;
  margin: 0 5px;
}
.productBox {
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
}
.productBox .item {
  background: #fff;
  width: 276px;
  height: 348px;
  text-align: center;
  margin: 20px 30px 0 0;
  position: relative;
}
.productBox .item .tip {
  background: #fc5b74;
  color: #fff;
  border-bottom-left-radius: 20px;
  padding: 5px 20px;
  position: absolute;
  right: 0;
  top: 0;
}
.productBox .item .more {
  position: absolute;
  right: 20px;
  top: 10px;
}
.productBox .item:hover {
  background: #fff;
  box-shadow: #efefef 0 0 5px;
}
.productBox .item:nth-child(4n) {
  margin-right: 0;
}
.productBox .item .image {
  width: 137px;
  height: 137px;
  background-size: 100%;
  margin: 50px auto 20px;
}
.productBox .item .title {
  font-size: 16px;
  line-height: 30px;
  padding: 0 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.productBox .item .price {
  margin: 20px 0;
}
.productBox .item .price span {
  color: #d81e06;
  font-weight: bold;
}
.productBox .item .btn {
  background: #fad07c;
  width: 180px;
  margin: 0 auto;
  padding: 10px 20px;
  border-radius: 50px;
}
.productBox .item a .btn {
  color: #333;
}
</style>
